import React, {useEffect} from 'react';
import {Toggle} from "../../../../components";
import {useViewerStore} from "../../../../store/store";
import {
    GetShadeCol
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/RefreshShade";
import {GetRoundNum} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Common";

interface SceneViewer {
    hideObject: (name: string, hidden: boolean) => void;
}

const WhatIfAnalysis: React.FC = () => {
    const {
        sceneViewer,
        utilityWattage,
        totalSystemSize,
        actualWattage,
        efficiency,
        modeCount,
        multiplier,
        isHideAllTreeWhatIfAnalysis,
        isHideAllObstWhatIfAnalysis,
        isHideGhostObstWhatIfAnalysis,
        isHideGhostTreeWhatIfAnalysis,
    } = useViewerStore(state => ({
        sceneViewer: state.sceneViewer as SceneViewer,
        utilityWattage: state.utilityWattage,
        totalSystemSize: state.totalSystemSize,
        actualWattage: state.actualWattage,
        efficiency: state.efficiency,
        modeCount: state.modeCount,
        multiplier: state.multiplier,
        isHideAllTreeWhatIfAnalysis: state.isHideAllTreeWhatIfAnalysis,
        isHideAllObstWhatIfAnalysis: state.isHideAllObstWhatIfAnalysis,
        isHideGhostObstWhatIfAnalysis: state.isHideGhostObstWhatIfAnalysis,
        isHideGhostTreeWhatIfAnalysis: state.isHideGhostTreeWhatIfAnalysis,
    }));

    const onCheckChangeHideAllTree = () => {
        sceneViewer.hideObject("WhatIfAllTrees", !isHideAllTreeWhatIfAnalysis);
        useViewerStore.setState({isHideAllTreeWhatIfAnalysis: !isHideAllTreeWhatIfAnalysis});
    };

    const onCheckChangeHideAllObst = () => {
        sceneViewer.hideObject("WhatIfAllObst", !isHideAllObstWhatIfAnalysis);
        useViewerStore.setState({isHideAllObstWhatIfAnalysis: !isHideAllObstWhatIfAnalysis});
    };

    const onCheckChangeHideGhostTree = () => {
        if (isHideAllTreeWhatIfAnalysis) {
            sceneViewer.hideObject("WhatIfAllTrees", false);
            useViewerStore.setState({isHideAllTreeWhatIfAnalysis: false});
        }
        sceneViewer.hideObject("GhostTree", !isHideGhostTreeWhatIfAnalysis);
        useViewerStore.setState({isHideGhostTreeWhatIfAnalysis: !isHideGhostTreeWhatIfAnalysis});
    };

    const onCheckChangeHideGhostObst = () => {
        if (isHideAllObstWhatIfAnalysis) {
            sceneViewer.hideObject("WhatIfAllObst", false);
            useViewerStore.setState({isHideAllObstWhatIfAnalysis: false});
        }
        sceneViewer.hideObject("GhostObst", !isHideGhostObstWhatIfAnalysis);
        useViewerStore.setState({isHideGhostObstWhatIfAnalysis: !isHideGhostObstWhatIfAnalysis});
    };

    useEffect(() => {
        return () => {
            sceneViewer.hideObject("WhatIfAllTrees", false);
            sceneViewer.hideObject("WhatIfAllObst", false);
            useViewerStore.setState({
                isHideAllTreeWhatIfAnalysis: false,
                isHideAllObstWhatIfAnalysis: false,
                isHideGhostObstWhatIfAnalysis: false,
                isHideGhostTreeWhatIfAnalysis: false,
            });
        };
    }, []);

    return (
        <div className="tab__inner">
            <div className="tab__title">
        <span className="tab__title--text tab__title--flex">
          What If Analysis
        </span>
            </div>
            <div className="tab__column">
                <div className="tab__data">
                    <div className='whatif-bar-wrapper'>
                        <div className='whatif-bar-inner'>
                            <div className='whatif-stick-wrapper'>
                                <div
                                    className='whatif-stick-inner'
                                    style={{
                                        height: `${efficiency}%`,
                                        backgroundColor: GetShadeCol(efficiency, true) as string,
                                    }}
                                />
                            </div>
                            <div className='whatif-value-wrapper' style={{bottom: `${efficiency}%`}}>
                                <div className='whatif-value-inner'>
                                    <div
                                        className='whatif-value-circle'
                                        style={{backgroundColor: GetShadeCol(efficiency, true) as string}}
                                    />
                                    <div className='whatif-value-label'>{efficiency}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab__flex justify-between">
                        <span className="tab__column--title">TOTAL SYSTEM SIZE</span>
                        <span className="tab__column--title primary">
              {GetRoundNum(totalSystemSize, 2)} &nbsp; kW
            </span>
                    </div>
                    <ul className="tab__data--list">
                        <li>
                            <span>{modeCount}</span>
                            <span>Module{modeCount === 1 ? '' : 's'}</span>
                        </li>
                        <li>
                            <span>{efficiency}</span>
                            <span>Efficiency</span>
                        </li>
                        <li>
                            <span>{multiplier}</span>
                            <span>Multiplier</span>
                        </li>
                    </ul>
                    <div className="tab__flex justify-between mt-2">
                        <div className="text-center">
                            <span className="tab__column--title">kWh - Utility</span>
                            <span className="tab__column--title orange">
                {GetRoundNum(utilityWattage, 2)?.toLocaleString()}
              </span>
                        </div>
                        <div className="text-center">
                            <span className="tab__column--title">kWh - Actual</span>
                            <span className="tab__column--title primary">
                {GetRoundNum(actualWattage, 2)?.toLocaleString()}
              </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="tab__column">
                <div className="tab__flex justify-between mb-2">
                    <span className="tab__column--subtitle mb-0">Remove All Trees</span>
                    <Toggle on={isHideAllTreeWhatIfAnalysis} onChange={onCheckChangeHideAllTree}/>
                </div>
                <div className="tab__flex justify-between mb-2">
                    <span className="tab__column--subtitle mb-0">Remove All Obstructions</span>
                    <Toggle on={isHideAllObstWhatIfAnalysis} onChange={onCheckChangeHideAllObst}/>
                </div>
                <div className="tab__flex justify-between mb-2">
                    <span className="tab__column--subtitle mb-0">Remove Ghost Trees</span>
                    <Toggle on={isHideGhostTreeWhatIfAnalysis} onChange={onCheckChangeHideGhostTree}/>
                </div>
                <div className="tab__flex justify-between mb-2">
                    <span className="tab__column--subtitle mb-0">Remove Ghost Obstructions</span>
                    <Toggle on={isHideGhostObstWhatIfAnalysis} onChange={onCheckChangeHideGhostObst}/>
                </div>
            </div>
        </div>
    );
};

export default WhatIfAnalysis;